module.exports = __webpack_public_path__ + "static/img/8.2ec923a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/2/zh/8.png
// module id = boLc
// module chunks = 0